import React from 'react';
import { Text as JssText, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ImageTextCard } from '@greystar/designsystem';
import { TextCardItemProps } from '@greystar/ui';

const TextCardItem = (props: TextCardItemProps) => {
  const { heading, description } = props.fields;
  const { titleSize, titleColour } = props.params ?? {};

  const headingStyles = props?.params?.headingStyles as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

  return (
    <ImageTextCard
      titleSize={titleSize ?? 'large'}
      titleColour={titleColour ?? 'secondary'}
      title={<JssText field={heading} />}
      bodyText={<JssText field={description} />}
      headerAs={headingStyles}
    />
  );
};

export default withDatasourceCheck()<TextCardItemProps>(TextCardItem);
